var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDietIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4D8B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2139 19.5938C24.588 18.969 25.1802 18.0746 25.9281 17.2165H25.9289C26.5624 16.4881 27.8028 15.5534 27.8028 15.5534C27.9892 15.4125 27.9692 15.2162 27.7572 15.1175L26.258 14.4168C26.046 14.3176 25.7578 14.39 25.6173 14.5769C25.6173 14.5769 24.5084 16.1676 23.2033 19.5538C19.1678 17.7285 15.332 20.2851 15.332 24.7309C15.332 29.3745 18.9048 36.4284 23.7363 34.2992C28.8249 36.5012 32.143 29.375 32.143 24.7309C32.143 20.2468 28.695 17.6179 24.2139 19.5938Z",
    fill: "#5F4728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1218 17.9966C23.355 17.977 23.5611 17.7705 23.5798 17.5377C23.5798 17.5377 23.7296 15.7218 22.4641 14.455C21.1947 13.1877 19.3822 13.3389 19.3822 13.3389C19.1489 13.3584 18.9429 13.5649 18.9237 13.7977C18.9237 13.7977 18.7713 15.6145 20.0386 16.8817C21.305 18.1477 23.1218 17.9966 23.1218 17.9966Z",
    fill: "#A78254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDietIcon);
export default __webpack_public_path__ + "static/media/card-diet-icon.242ae770b99aeea44ca217924c273811.svg";
export { ForwardRef as ReactComponent };